exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-resv-container[data-v-1f5d34ce]{border-radius:4px;border:1px solid #e6e6e6;padding:12px;line-height:2rem;font-size:13px;margin-bottom:12px}.lp-title[data-v-1f5d34ce]{font-weight:600;margin-right:8px}.negative-div[data-v-1f5d34ce]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:$negative}", ""]);

// exports
